import { useState, Fragment } from 'react';
import SimpleHomeBreadcrumb from '@Components/Shared/SimpleHomeBreadcrumb';
import GlobalBrandsMapView from './GlobalBrandsMapView';
const GlobalBrandsView = (props) => {
	
	return (
		<>
			<div className='global-brands-container'>
				<div className='breadcrumbs'>
					<SimpleHomeBreadcrumb homeRoute={props.BreadCrumbHomeRoute} displayText={props.BreadCrumbText} />
				</div>
				<section className="blurb-content" dangerouslySetInnerHTML={{ __html: props.PageBlurb }} />
				<GlobalBrandsMapView PageTitle={props.GlobalBrandsMap.PageTitle} GlobalBrands={props.GlobalBrandsMap.GlobalBrands} /> 
			</div>

		</>   
	);
};

export default GlobalBrandsView;
global.GlobalBrandsView = GlobalBrandsView;